import React from "react";
import MenuLateral from "../MenuLateral/MenuLateral";
import "./ComponentePadrao.css";

const ComponentePadrao = ({ children }) => {
    return (  
        <div className="container-principal">
            <MenuLateral />
            <div className="content-wrapper">
                {children}
            </div>
        </div>
    );
}
 
export default ComponentePadrao;